const PDP = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      d="M0 0h512m0 512H0M0 0h512v512H0z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M0 256v256h512V0H0zm293.4-134.15c8.9 7.6 12 15.88 11.13 31.53l-.67 13.19-62.77 1.12c-61.67 1.11-63 1.11-67.9 6.26-5.12 4.91-5.12 6.26-6.23 68.19l-1.12 63.05L150 305c-11.35 0-17.81-1.11-22-4-11.8-7.83-12.47-12.52-11.8-94.13l.67-74.45 5.56-6c3.12-3.35 7.57-6.93 10-7.82 2.45-1.12 38.29-2 79.47-2l74.8-.23zm90.38 89.43c11.8 7.83 12.46 12.3 12.46 90.55 0 78.93-.44 82.51-13.13 90.11-5.79 3.35-14.69 3.8-81.48 3.8-82.36 0-84.59-.23-91.26-13.64-2.45-4.47-3.34-11.4-2.9-21.69l.67-15 63.44-1.12c34.95-.67 63.67-1.56 64.11-1.78.23-.23 2.45-3.81 4.9-7.83 4.23-6.71 4.45-11.18 4.45-66.63 0-32.64.67-60.14 1.78-61 2.68-2.92 30.95.43 36.96 4.23zM305 246.83c0 36.67-.22 39.13-5.12 46.28-7.56 11.41-16.47 13.42-57 12.75l-34.73-.67-.67-38c-.67-40.69.67-47.18 10.24-54.78 4.9-4 9.13-4.47 46.3-4.47h41z"
      fill="#010101"
    />
  </svg>
);

export default PDP;
